import { UrlObject } from "url";

import React, { useEffect, useState } from "react";
import Link from "next/link";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";

import Styled from "./index.styles";

type Url = string | UrlObject;

export type LinkProps = {
  href: Url;
  as?: Url;
  replace?: boolean;
  scroll?: boolean;
  shallow?: boolean;
  passHref?: boolean;
  prefetch?: boolean;
  locale?: string | false;
};
interface BreadcrumbItem {
  breadcrumb: string;
  href: string;
}

export default function SupportBreadcrumb({
  title,
  className,
}: {
  title?: string;
  className?: string;
}) {
  const { t } = useTranslation(["support-new"]);

  const [breadcrumbsList, setBreadcrumbsList] = useState<BreadcrumbItem[]>([]);

  const { asPath } = useRouter();

  useEffect(() => {
    if (asPath) {
      const linkPath = asPath.split("/");
      linkPath.shift();

      const pathArray = linkPath.map((path, i) => {
        return {
          breadcrumb: path,
          href: "/" + linkPath.slice(0, i + 1).join("/"),
        };
      });

      setBreadcrumbsList(pathArray);
    }
  }, [asPath]);

  function convertBreadcrumbToBoardTitle(string: string) {
    return string
      .replace(/-/g, " ")
      .replace(/support/g, t("support-new:공통_고객지원"))
      .replace(/guide/g, t("support-new:공통_가이드"))
      .replace(/use/g, t("support-new:공통_이용방법"))
      .replace(/tradeterms/g, t("support-new:공통_무역용어_운송프로세스"))
      .replace(/faq/g, "FAQ")
      .replace(/notice/g, t("support-new:공통_공지사항"))
      .replace(/onlinelecture/g, t("support-new:공통_소개_활용_동영상"));
  }

  function checkBreadcrumbHasLink(breadcrumb: string) {
    const breadcrumbWithoutLink = ["support"];

    return breadcrumbWithoutLink.includes(breadcrumb);
  }

  if (!breadcrumbsList.length) return null;

  return (
    <Styled.container className={`${className ? className : ""} breadcrumbs`}>
      <nav aria-label="breadcrumbs">
        <ol>
          {breadcrumbsList.map(({ breadcrumb, href }, i) => {
            if (checkBreadcrumbHasLink(breadcrumb)) {
              return (
                <Styled.breadcrumb key={href} className="breadcrumb">
                  <span className="breadcrumb-title">
                    {convertBreadcrumbToBoardTitle(breadcrumb)}
                  </span>
                </Styled.breadcrumb>
              );
            }

            return (
              <Styled.breadcrumb
                key={href}
                className="breadcrumb"
                isRecentDepth={breadcrumbsList.length - 1 === i}
              >
                <Link href={href}>
                  <a>
                    <span className="breadcrumb-title">
                      {isNaN(Number(breadcrumb))
                        ? convertBreadcrumbToBoardTitle(breadcrumb)
                        : title}
                    </span>
                  </a>
                </Link>
              </Styled.breadcrumb>
            );
          })}
        </ol>
      </nav>
    </Styled.container>
  );
}
